export default __webpack_public_path__ + "static/media/clinic.3d09d36b.svg";